import { observable, action, runInAction, makeAutoObservable } from "mobx";
import agent from "../api/agent";
import { RootStore } from "./rootStore";
import { toast } from "react-toastify";
import { IResolution } from "../models/resolution";
import { showError } from "../util/errorTypeEnumsOptions";

export default class ResolutionStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @observable loadData = false;
  @observable resolutions: IResolution[] = [];
  @observable btSyncResolution = false;

  @action changeStatebtSyncResolution = () => {
    this.btSyncResolution = !this.btSyncResolution;
  };

  @action getResolutions = async () => {
    try {
      const resol = await agent.Resolutions.getResolutions();
      runInAction(() => {
        this.resolutions = resol;
      });
    } catch (error) {
      showError(error);
    }
    runInAction(() => {
      this.loadData = true;
    });
  };

  @action syncResolutions = async () => {
    try {
      this.changeStatebtSyncResolution();
      const r = await agent.Resolutions.syncResolutions();
      if (r.success) {
        this.getResolutions();
        this.changeStatebtSyncResolution();
        toast.success("Sincronización exitosa");
      } else {
        this.changeStatebtSyncResolution();
        toast.error("Error sincronizando:" + r.errorMessage);
      }
    } catch (error) {
      this.changeStatebtSyncResolution();
      showError(error);
    }
  };
}
